export enum CADConnectionType {
  None = 0,
  PowerEngage = 1,
  PowerConnect = 2
}
